var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 102,
    viewBox: "0 0 96 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3845 33.4494C25.3027 33.4494 20.3724 38.3797 20.3724 44.4616C20.3724 50.5434 25.3027 55.4737 31.3845 55.4737C36.1777 55.4737 40.2581 52.4108 41.7703 48.1324C41.9603 47.5948 42.5502 47.313 43.0877 47.503C43.6253 47.693 43.9071 48.2829 43.7171 48.8204C41.9224 53.8981 37.0799 57.5385 31.3845 57.5385C24.1624 57.5385 18.3076 51.6837 18.3076 44.4616C18.3076 37.2394 24.1624 31.3846 31.3845 31.3846C35.8564 31.3846 39.8036 33.6302 42.1601 37.0506C42.805 37.9866 43.3313 39.0112 43.7171 40.1027C43.9071 40.6403 43.6253 41.2301 43.0877 41.4201C42.5502 41.6101 41.9603 41.3283 41.7703 40.7908C41.4459 39.8729 41.0031 39.0106 40.4598 38.2221C38.4721 35.3371 35.1487 33.4494 31.3845 33.4494ZM43.3349 42.6284C43.9039 42.591 44.3954 43.0218 44.4329 43.5908C44.4518 43.8787 44.4615 44.1691 44.4615 44.4616C44.4615 44.754 44.4518 45.0444 44.4329 45.3323C44.3954 45.9013 43.9039 46.3321 43.3349 46.2947C42.766 46.2572 42.3351 45.7657 42.3726 45.1967C42.3885 44.9539 42.3967 44.7087 42.3967 44.4616C42.3967 44.2144 42.3885 43.9692 42.3726 43.7264C42.3351 43.1575 42.766 42.6659 43.3349 42.6284Z",
    fill: "#0098FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9028 1.22046C73.9028 0.546419 74.4414 0 75.1058 0H78.7549C85.8147 0 91.8778 3.58809 95.2893 9.3512C95.6314 9.92904 95.4469 10.6788 94.8773 11.0258C94.3078 11.3728 93.5687 11.1857 93.2267 10.6079C90.2523 5.58318 84.9741 2.44092 78.7549 2.44092H75.1058C74.4414 2.44092 73.9028 1.8945 73.9028 1.22046Z",
    fill: "#0098FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1294 1.22046C64.1294 0.546419 64.668 0 65.3324 0H68.9815C69.6459 0 70.1844 0.546419 70.1844 1.22046C70.1844 1.8945 69.6459 2.44092 68.9815 2.44092H65.3324C64.668 2.44092 64.1294 1.8945 64.1294 1.22046Z",
    fill: "#0098FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.581106 90.9518C1.14978 90.6032 1.88929 90.7884 2.23284 91.3653C5.2134 96.3705 10.5244 99.5591 16.7209 99.5591H18.5454C19.2098 99.5591 19.7484 100.106 19.7484 100.78C19.7484 101.454 19.2098 102 18.5454 102H16.7209C9.67486 102 3.58611 98.3583 0.173497 92.6275C-0.170059 92.0506 0.0124337 91.3003 0.581106 90.9518Z",
    fill: "#0098FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9463 100.779C22.9463 100.105 23.4849 99.559 24.1493 99.559H27.7984C28.4628 99.559 29.0013 100.105 29.0013 100.779C29.0013 101.454 28.4628 102 27.7984 102H24.1493C23.4849 102 22.9463 101.454 22.9463 100.779Z",
    fill: "#0098FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.721 9.44837C11.3389 9.44837 6.97678 13.8738 6.97678 19.3341V82.2691C6.97678 87.7294 11.3389 92.1549 16.721 92.1549H78.7553C84.1374 92.1549 88.4995 87.7294 88.4995 82.2691V19.3341C88.4995 13.8738 84.1374 9.44837 78.7553 9.44837H16.721ZM4.5708 19.3341C4.5708 12.5257 10.0101 7.00745 16.721 7.00745H78.7553C85.4662 7.00745 90.9055 12.5257 90.9055 19.3341V82.2691C90.9055 89.0775 85.4662 94.5958 78.7553 94.5958H16.721C10.0101 94.5958 4.5708 89.0775 4.5708 82.2691V19.3341Z",
    fill: "#0098FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7021 24.2567H5.77344V21.8157H89.7021V24.2567Z",
    fill: "#0098FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2573 15.1032C15.2573 14.4292 15.7959 13.8828 16.4603 13.8828H18.4152C19.0796 13.8828 19.6182 14.4292 19.6182 15.1032C19.6182 15.7773 19.0796 16.3237 18.4152 16.3237H16.4603C15.7959 16.3237 15.2573 15.7773 15.2573 15.1032Z",
    fill: "#0098FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0767 15.1032C23.0767 14.4292 23.6153 13.8828 24.2797 13.8828H26.2345C26.8989 13.8828 27.4375 14.4292 27.4375 15.1032C27.4375 15.7773 26.8989 16.3237 26.2345 16.3237H24.2797C23.6153 16.3237 23.0767 15.7773 23.0767 15.1032Z",
    fill: "#0098FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.896 15.1032C30.896 14.4292 31.4346 13.8828 32.099 13.8828H34.0538C34.7182 13.8828 35.2568 14.4292 35.2568 15.1032C35.2568 15.7773 34.7182 16.3237 34.0538 16.3237H32.099C31.4346 16.3237 30.896 15.7773 30.896 15.1032Z",
    fill: "#0098FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9229 66.6923C20.9229 65.9701 21.6021 65.3846 22.44 65.3846H41.6365C42.4744 65.3846 43.1536 65.9701 43.1536 66.6923C43.1536 67.4146 42.4744 68 41.6365 68H22.44C21.6021 68 20.9229 67.4146 20.9229 66.6923Z",
    fill: "#0098FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9229 74.5385C20.9229 73.8162 21.6021 73.2308 22.44 73.2308H41.6365C42.4744 73.2308 43.1536 73.8162 43.1536 74.5385C43.1536 75.2607 42.4744 75.8462 41.6365 75.8462H22.44C21.6021 75.8462 20.9229 75.2607 20.9229 74.5385Z",
    fill: "#0098FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3076 66.6923C52.3076 65.9701 52.9869 65.3846 53.8247 65.3846H73.0213C73.8591 65.3846 74.5384 65.9701 74.5384 66.6923C74.5384 67.4146 73.8591 68 73.0213 68H53.8247C52.9869 68 52.3076 67.4146 52.3076 66.6923Z",
    fill: "#0098FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3076 74.5385C52.3076 73.8162 52.9869 73.2308 53.8247 73.2308H73.0213C73.8591 73.2308 74.5384 73.8162 74.5384 74.5385C74.5384 75.2607 73.8591 75.8462 73.0213 75.8462H53.8247C52.9869 75.8462 52.3076 75.2607 52.3076 74.5385Z",
    fill: "#0098FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9229 82.3845C20.9229 81.6623 21.6021 81.0768 22.44 81.0768H41.6365C42.4744 81.0768 43.1536 81.6623 43.1536 82.3845C43.1536 83.1068 42.4744 83.6922 41.6365 83.6922H22.44C21.6021 83.6922 20.9229 83.1068 20.9229 82.3845Z",
    fill: "#0098FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3076 82.3845C52.3076 81.6623 52.9869 81.0768 53.8247 81.0768H73.0213C73.8591 81.0768 74.5384 81.6623 74.5384 82.3845C74.5384 83.1068 73.8591 83.6922 73.0213 83.6922H53.8247C52.9869 83.6922 52.3076 83.1068 52.3076 82.3845Z",
    fill: "#0098FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3076 33.954C52.3076 32.5502 53.4631 31.3846 54.923 31.3846C56.3832 31.3846 57.5384 32.5513 57.5384 33.954V56.2308H55.8487V33.954C55.8487 33.4235 55.4175 33.0215 54.923 33.0215C54.4282 33.0215 53.9973 33.4229 53.9973 33.954V58.517H73.2307V60.1539H52.3076V33.954Z",
    fill: "#0098FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1538 33.954C60.1538 32.5502 61.3093 31.3846 62.7692 31.3846C64.2294 31.3846 65.3846 32.5513 65.3846 33.954V56.2308H63.6949V33.954C63.6949 33.4235 63.2637 33.0215 62.7692 33.0215C62.2744 33.0215 61.8435 33.4229 61.8435 33.954V58.517H64.5397V60.1539H60.1538V33.954Z",
    fill: "#0098FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 33.954C68 32.5502 69.1555 31.3846 70.6154 31.3846C72.0756 31.3846 73.2308 32.5513 73.2308 33.954V56.2308H71.5411V33.954C71.5411 33.4235 71.1099 33.0215 70.6154 33.0215C70.1206 33.0215 69.6897 33.4229 69.6897 33.954V58.517H72.3859V60.1539H68V33.954Z",
    fill: "#0098FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.e14139dec3cf67bb67a3a6a5e49198d9.svg";
export { ForwardRef as ReactComponent };